import AvailabilitiesCalendarDay from './AvailabilitiesCalendarDay';

export default AvailabilitiesCalendarDay;
